import { render, staticRenderFns } from "./MFAUnenrollment.vue?vue&type=template&id=543abb56&"
import script from "./MFAUnenrollment.vue?vue&type=script&lang=js&"
export * from "./MFAUnenrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports